import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";

const KEY = "barecord_launch_banner";

export function LaunchBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(KEY) === "dismissed";
    setVisible(!dismissed);
    window.dispatchEvent(new CustomEvent("barecord-banner-change", { detail: { visible: !dismissed } }));
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "dismissed");
    setVisible(false);
    window.dispatchEvent(new CustomEvent("barecord-banner-change", { detail: { visible: false } }));
  };

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[60] h-10 bg-paper text-black border-b border-black/10"
      data-testid="launch-banner"
    >
      <div className="max-w-[1400px] mx-auto h-full px-6 lg:px-10 flex items-center justify-center relative">
        <Link
          to="/barecord/register"
          data-testid="launch-banner-cta"
          className="group inline-flex items-center gap-1.5 text-xs sm:text-sm font-medium tracking-tight hover:opacity-70 transition-opacity"
        >
          <span className="uppercase tracking-widest text-[10px] bg-black text-paper rounded-full px-2 py-0.5 mr-1">New</span>
          BArecord launches Nov 7 — reserve your spot
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </Link>
        <button
          onClick={dismiss}
          data-testid="launch-banner-dismiss"
          aria-label="Dismiss announcement"
          className="absolute right-4 lg:right-8 p-1 hover:opacity-60 transition-opacity"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
